import { Action, createReducer, on } from '@ngrx/store';

import {
  fetchUserFailure,
  fetchUserFailureAdmin,
  fetchUserFailureNoAccess,
  fetchUserSuccess,
  fetchUserSuccessNoAccess,
  logOut,
  login,
  setClientId,
  setClinicId,
  setCompanyId,
  setProviderId, setRoles,
  setSiWeb
} from '../actions/profile.actions';

import { IProfileState } from './../interfaces/profile';

const storedData = JSON.parse(localStorage.getItem('current_user')!);
const initialState: IProfileState = {
  authorized: false
};

const profileReducer = createReducer(
  storedData || initialState,
  on(login, (state, props) => {
    const newState = {
      ...state,
      ...props,
      name: `${props.firstName} ${props.lastName}`,
      authorized: true,
      loading: false,
      error: false,
      noAccess: false
    };

    return newState;
  }),
  on(fetchUserSuccess, (state, payload) => ({
    ...state,
    authorized: true,
    loading: false,
    noAccess: false,
    hasNewMessages: payload.hasNewMessages,
    vcRazonSocial: payload.vcRazonSocial,
    iIdEmpresa: payload.iIdEmpresa,
    siEstadoCredito: payload.siEstadoCredito,
    siEstadoCotizacion: payload.siEstadoCotizacion,
    siAccesoalaWeb: payload.siAccesoalaWeb,
    vcMensajeCliente: payload.vcMensajeCliente,
    siFormaAprobarValorizacion: payload.siFormaAprobarValorizacion,
    iIdCotiEmpresa: payload.iIdCotiEmpresa,
    bCargaValorizacionesaContratas: payload.bCargaValorizacionesaContratas,
    bPedirPDFSolicitudEnCita: payload.bPedirPDFSolicitudEnCita,
    iIdFormatoSolitudEMO: payload.iIdFormatoSolitudEMO,
    iVersion: payload.iVersion,
    isPremium: payload.isPremium,
    iPendientes: payload.iPendientes,
    name: payload.name
  })),
  on(setCompanyId, (state, props) => ({
    ...state,
    iIdEmpresa: props.id,
    vcRazonSocial: props.name,
    siEstadoCredito: props.siEstadoCredito,
    siEstadoCotizacion: props.siEstadoCotizacion,
    siAccesoalaWeb: props.siAccesoalaWeb,
    vcMensajeCliente: props.vcMensajeCliente,
    siFormaAprobarValorizacion: props.siFormaAprobarValorizacion,
    iIdCotiEmpresa: props.iIdCotiEmpresa,
    iVersion: props.iVersion,
    bCargaValorizacionesaContratas: props.bCargaValorizacionesaContratas,
    bPedirPDFSolicitudEnCita: props.bPedirPDFSolicitudEnCita,
    iIdFormatoSolitudEMO: props.iIdFormatoSolitudEMO,
  })),
  on(setClinicId, (state, props) => ({
    ...state,
    iIdSede: props.iIdSede,
    vcNombreSede: props.vcNombreSede,
  })),
  on(setSiWeb, (state, props) => ({
    ...state,
    siWeb: props.siWeb,
  })),
  on(setClientId, (state, props) => ({
    ...state,
    iIdClient: props.iIdClient,
    vcClient: props.vcClient
  })),
  on(setProviderId, (state, props) => ({
    ...state,
    iIdProvider: props.iIdProvider,
    vcProvider: props.vcProvider
  })),
  on(setRoles, (state, props) => ({
    ...state,
    roles: props.roles
  })),
  on(fetchUserFailure, state => ({ ...state, loading: false })),
  on(fetchUserFailureAdmin, state => ({ ...state, loading: false, noAccess: true })),
  on(fetchUserSuccessNoAccess, (state, payload) => ({
    ...state,
    authorized: true,
    loading: false,
    noAccess: false,
    errorMsgs: [...[payload.errorMsg]],
    hasNewMessages: payload.hasNewMessages,
    vcRazonSocial: payload.vcRazonSocial,
    iIdEmpresa: payload.iIdEmpresa,
    siEstadoCredito: payload.siEstadoCredito,
    siEstadoCotizacion: payload.siEstadoCotizacion,
    siAccesoalaWeb: payload.siAccesoalaWeb,
    vcMensajeCliente: payload.vcMensajeCliente,
    siFormaAprobarValorizacion: payload.siFormaAprobarValorizacion,
    iIdCotiEmpresa: payload.iIdCotiEmpresa,
    iVersion: payload.iVersion,
    bCargaValorizacionesaContratas: payload.bCargaValorizacionesaContratas,
    bPedirPDFSolicitudEnCita: payload.bPedirPDFSolicitudEnCita,
    iIdFormatoSolitudEMO: payload.iIdFormatoSolitudEMO,
    isPremium: payload.isPremium,
    iPendientes: payload.iPendientes,
    name: payload.name
  })),
  on(fetchUserFailureNoAccess, state => ({ ...state, loading: false, noAccess: true  })),
  on(logOut, () => ({ ...initialState }))
);

export function ProfileReducer(state: IProfileState | undefined, action: Action) {
  return profileReducer(state, action);
}
